import { useState, useEffect } from 'react';
import { debtService } from '../services/debtService';
import { useAuth } from '../../auth/contexts/AuthContext';
import { message } from 'antd';

export function useDebts() {
    const { currentUser } = useAuth();
    const [debts, setDebts] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchDebts = async () => {
        if (!currentUser) return;

        setLoading(true);
        try {
            const debtList = await debtService.getDebts(currentUser.uid);
            setDebts(debtList);
        } catch (error) {
            message.error('Lỗi khi tải danh sách nợ: ' + error.message);
        }
        setLoading(false);
    };

    const addDebt = async (debtData) => {
        try {
            await debtService.addDebt(currentUser.uid, debtData);
            message.success('Thêm nợ thành công!');
            fetchDebts();
        } catch (error) {
            message.error('Lỗi khi thêm nợ: ' + error.message);
            throw error;
        }
    };

    const updateDebt = async (debtId, debtData) => {
        try {
            await debtService.updateDebt(currentUser.uid, debtId, debtData);
            message.success('Cập nhật nợ thành công!');
            fetchDebts();
        } catch (error) {
            message.error('Lỗi khi cập nhật nợ: ' + error.message);
            throw error;
        }
    };

    const deleteDebt = async (debtId) => {
        try {
            await debtService.deleteDebt(currentUser.uid, debtId);
            message.success('Xóa nợ thành công!');
            fetchDebts();
        } catch (error) {
            message.error('Lỗi khi xóa nợ: ' + error.message);
            throw error;
        }
    };

    const updatePaidAmount = async (debtId, paidAmount, isFullyPaid) => {
        try {
            await debtService.updatePaidAmount(currentUser.uid, debtId, paidAmount, isFullyPaid);
            fetchDebts();
        } catch (error) {
            message.error('Lỗi khi cập nhật số tiền đã trả: ' + error.message);
            throw error;
        }
    };

    useEffect(() => {
        fetchDebts();
    }, [currentUser]);

    return {
        debts,
        loading,
        addDebt,
        updateDebt,
        deleteDebt,
        updatePaidAmount,
        refetch: fetchDebts
    };
}
